/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { action, observable } from 'mobx';
import { createResourceStoreHouse } from 'src/luis/core/stores/resourceStoreHouse';
import { QnaMakerRowMetricStore } from 'src/qnaMaker/core/stores/QnaMakerRowMetricStore';

export class QnaMakerMetricStore {
    public readonly id: string;

    public rowMetricStoreHouse = createResourceStoreHouse<QnaMakerRowMetricStore>();

    @observable public timestampToStartEditingOrAdding: number;

    @observable public totalNumberOfClicksBeforeSave: number;

    constructor(id: string) {
        this.id = id;
        this.timestampToStartEditingOrAdding = 0;
        this.totalNumberOfClicksBeforeSave = 0;
    }

    @action
    public setRowMetrics(items: QnaMakerRowMetricStore[]) {
        this.rowMetricStoreHouse.setItems(items);
    }

    @action
    public increaseTotalNumberOfClicksBeforeSave() {
        this.totalNumberOfClicksBeforeSave++;
    }

    @action
    public setTimestampToStartEditingOrAdding(timestamp: number) {
        if (this.timestampToStartEditingOrAdding === 0) {
            this.timestampToStartEditingOrAdding = timestamp;
        }
    }

    @action
    public resetMetricConfigsAfterSave() {
        this.timestampToStartEditingOrAdding = 0;
        this.totalNumberOfClicksBeforeSave = 0;
    }
}
